var render, staticRenderFns
import script from "./ChartAskue.vue?vue&type=script&lang=js&"
export * from "./ChartAskue.vue?vue&type=script&lang=js&"
import style0 from "./ChartAskue.vue?vue&type=style&index=0&id=1119d4af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1119d4af",
  null
  
)

export default component.exports